import { EarnTableView } from "./transaction.types";
import { EarnTableStateEnum } from "../enum/earn.enum";

/**Just to make sure that when we sue keys, that a transaction id is expected*/
export type TransactionId = string;

/**
 * All maskable column IDs in the earn table.
 * These match the columns with CheckboxHeaderRenderer in earn-draft.table.ts
 * Excludes: id, publishedAt, accountBalance, institution
 */
export const MASKABLE_COLUMN_IDS: (keyof EarnTableView)[] = [
  "description",
  "account",
  "transactionDate",
  "inOut",
  "currency",
  "amount",
  "source",
] as const;

/**Draft? Preview? Published?*/
export type EarnTableState = `${EarnTableStateEnum}`;
export type ColumnKey = keyof EarnTableView; // "desc" | "amount" | ...
export type HiddenColumns = Partial<Record<ColumnKey, true>>;
export type HiddenRows = Record<TransactionId, true>;
export type HiddenCells = Record<TransactionId, Partial<Record<ColumnKey, boolean>>>;
export type AppliedTransactionSet = Set<TransactionId>;
export type AppliedTransactionArray = TransactionId[];
export type EarnMaskStatus = "draft" | "published";
export type Section = "history" | "create";
export type EarnMask = {
  maskId: string;
  name: string; //in case user wants to name his bundle
  version: number;
  status: EarnMaskStatus;
  publishedAt: Date | null; // null for drafts
  updatedAt: Date | null; // for drafts
  columns: HiddenColumns;
  rows: HiddenRows;
  cells: HiddenCells;
  appliedToSet?: AppliedTransactionSet;
  appliedToArray: AppliedTransactionArray;
};

export type EarnRowMap = Map<TransactionId, true>;
export type EarnColumnMap = Map<ColumnKey, true>;
export type EarnCellMap = Map<TransactionId, EarnColumnMap>;

export type EarnMaskLookup = {
  rows: EarnRowMap;
  columns: EarnColumnMap;
  cells: EarnCellMap;
  appliedToRows: Set<TransactionId>;
};

export type EarnTableHeaderComponentParams = {
  toggleColumn: (colId: keyof EarnTableView, isShared: boolean) => void;
  isColumnHidden: (colId: keyof EarnTableView) => boolean;
  hasData: boolean;
};

export type EarnMaskWithMeta = {
  fileId: string;
  key: string;
  size: number;
  lastModified: string;
  eTag: string;
  data: EarnMask;
};

export type EarnVersion = {
  columns: Record<string, boolean>;
  rows: Record<string, boolean>;
  cells: Record<string, Record<string, boolean>>;
  name: string;
  publishedAt: string; // ISO
  maskId: string;
  appliedToSet: Record<string, true>;
  appliedToArray: string[];
  version: number; // e.g. 1,2,3...
  status: "draft" | "published";
  updatedAt: string; // ISO
  // derived at runtime:
  groupKey?: string; // YYYYMM01
  versionLabel?: string; // YYYYMM01.v{n}
  getRowClass?: (params: any) => string;
  getRowStyle?: (params: any) => Record<string, string>;
};
